module.exports = __webpack_public_path__ + "img/piktogram@2x.3881b54a.png";